module.exports = __webpack_public_path__ + "img/clean_energy.81f9fde8.svg";